import type {
  Product,
  SelectedOption,
} from "@shopify/hydrogen-react/storefront-api-types";
import { useQuery } from "react-query";
import { client } from "./client";

const PRODUCT_QUERY = `#graphql
  query product($handle: String!, $selectedOptions: [SelectedOptionInput!]!) {
    product(handle: $handle) {
      id
      title
      vendor
      description
      descriptionHtml
      featuredImage {
        id
        url
        altText
        width
        height
      }
      metafield(key: "artist_id", namespace: "hug") {
        key
        value
        namespace
      }
      options {
        name,
        values
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
        minVariantPrice {
          amount
          currencyCode
        }
      }
      selectedVariant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        id
        availableForSale
        selectedOptions {
          name
          value
        }
        image {
          id
          url
          altText
          width
          height
        }
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        sku
        title
        unitPrice {
          amount
          currencyCode
        }
        product {
          title
          handle
        }
      }
      variants(first: 1) {
        nodes {
          id
          title
          availableForSale
          price {
            currencyCode
            amount
          }
          compareAtPrice {
            currencyCode
            amount
          }
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

const getProduct = (handle: string, selectedOptions?: SelectedOption[]) =>
  client.query<{ data: { product?: Product } }>(PRODUCT_QUERY, {
    handle,
    selectedOptions,
  });

const useProductQuery = (handle: string, options?: SelectedOption[]) =>
  useQuery(
    ["product", "detail", handle, options],
    () => getProduct(handle, options),
    {
      select: (d) => d.data.product,
      onSuccess: (resp) => {
        // eslint-disable-next-line
        console.log("query success");
        // eslint-disable-next-line
        console.log(
          "selected variant: ",
          (resp as any)?.selectedVariant?.title,
        );
      },
    },
  );

export { useProductQuery };
